
import { defineComponent, reactive, ref } from 'vue';

// icons
import { navigateOutline, personCircle, mail, call, people, star, school, book, informationCircleOutline, close, arrowBack, carOutline, } from 'ionicons/icons';

// components
import { IonPage, IonHeader, IonFooter, IonModal, IonTitle, IonToolbar, IonContent, IonGrid,
        IonCard, IonCardContent, IonItem, IonLabel, IonInput, IonButton,
        IonIcon, IonList, IonListHeader, IonRadioGroup, IonRadio,
        IonDatetime, IonSelect, IonSelectOption, IonSpinner,
        onIonViewDidEnter, onIonViewWillLeave,
        loadingController, alertController, isPlatform, modalController, } from '@ionic/vue';
import ImageModal from '@/components/ImageModal.vue';

// composables
import { Browser } from '@capacitor/browser';
import { useRoute, useRouter } from 'vue-router';
import { utils } from '@/composables/utils';
import config from '@/config';

// Firebase
import firebase from 'firebase/app';
import 'firebase/auth';

// Services
import api from '@/services/api';

// Lottie
import lottie from 'lottie-web';

// Stripe
import { loadStripe, Stripe } from '@stripe/stripe-js';

// Moment.js
import moment from 'moment';

export default defineComponent({
  name: 'HomePage',
  components: { IonPage, IonHeader, IonFooter, IonModal, IonTitle, IonToolbar, IonContent, IonGrid,
                IonCard, IonCardContent, IonItem, IonLabel, IonInput, IonButton,
                IonIcon, IonList, IonListHeader, IonRadioGroup, IonRadio,
                IonDatetime, IonSelect, IonSelectOption, IonSpinner, },
  setup() {
    // lottie
    let easterEggAnim;

    // reCAPTCHA
    /*
    const window: any = {
      recaptchaVerifier: undefined,
      confirmationResult: undefined,
      verificationId: undefined, // for iOS
    };*/
    const recaptchaDiv = ref<any>(null);
    
    // Composables
    const route = useRoute();
    const router = useRouter();
    const { focusInputField, presentPrompt, presentAlert, formatDate, getProxyImgLink, } = utils();

    // Route param (getting brand info)
    const currBrandId = route.params.id;
    const loadingData = ref(true);
    const currBrand = ref<any>({});
    const holidayDates = ref<any>([]);

    // Input Fields References
    const nameInput = ref(null);
    const phoneInput = ref(null);
    const emailInput = ref(null);
    const submitBtn = ref<any>(null);

    // Application
    const application = reactive({
      brandId: "",
      id: "",
      name: "",
      phone: "",
      email: "",
      queryString: JSON.stringify(route.query),
      submittingForm: false,
    });

    // Booking Order
    const orderObj = reactive({
      brandId: "",
      applicationId: "",
      customerName: "",
      contactPhone: "",
      customerEmail: "",

      deliveryDate: "",
      deliveryTime: "",
      location: "",

      giftId: "",
      giftName: "",
      giftImageLink: "",
      giftPrice: 0,
      giftDeposit: 0,

      paymentMethod: "paypal",
      transactionFee: 5,
      //paymentMethod: "payme",
      //transactionFee: 0,
      stripeToken: "",

      submittingOrder: false,
    });
    const getOrderTotalPrice = () => (Number(orderObj.giftPrice) + Number(orderObj.giftDeposit) + Number(orderObj.transactionFee));

    // Booking Date & Time & Location Options
    const dateInputModal = ref(null);
    const availableTimeSlots = ref<any>([]);
    const locationOptions = ref([]);

    const section = ref(1);
    const isGiftModalOpened = ref(false);

    // Timer
    const countdown = 900; // 15 minutes in seconds
    let timer; // setInterval object

    // Stripe
    const stripe = ref<Stripe>();
    const card = ref<any>(null);
    const cardElement = ref<any>(null);
    const cardErrors = ref<any>(null);
    const inviInput = ref<any>(null); // FOR FIXING IOS KEYBOARD PROBLEM

    loadStripe(config.Stripe.publishableKey).then((res: any) => {
      stripe.value = res;
      const elements = res.elements();
      const style = {
        base: {
          color: '#32325d',
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: 'antialiased',
          fontSize: '16px',
          '::placeholder': {
            color: '#aab7c4'
          }
        },
        invalid: {
          color: '#fa755a',
          iconColor: '#fa755a'
        }
      };
      card.value = elements.create('card', { hidePostalCode: true, style }); // Create an instance of the card Element.
      card.value.mount(cardElement.value); // Add an instance of the card Element into the `card-element` <div>.

      // Handle real-time validation errors from the card Element.
      card.value.on('change', (ev: any) => {
        cardErrors.value.textContent = ev.error ? ev.error.message : '';
      });
      if (isPlatform('ios')) { // iOS bug fix
        card.value.on('blur', (e: any) => {
          inviInput.value.focus();
          setTimeout(() => inviInput.value.blur());
        })
      }
    })

    // Methods
    const updateApplication = async (key, val) => {
      api.updateApplication(application.id, { [key]: val });
    }
    const submitApplication = async () => {
      const msg = `<b>確認參與活動？</b>
      <p>名字：${application.name}</p>
      <p>電話：${application.phone}</p>
      <p>電郵：${application.email}</p>
      `
      presentPrompt(msg, async () => {
        application.submittingForm = true;
        const loading = await loadingController.create({ duration: 60000 });
        await loading.present();
        const { applicationId, errorMsg, gift } = await api.insertApplication(application);
        application.submittingForm = false;
        loading.dismiss();

        if (errorMsg) {
          // Lucky draw failed, present error msg
          presentAlert(errorMsg);
        }
        else {
          // Lucky draw success, go to next section
          orderObj.customerName = application.name;
          orderObj.contactPhone = application.phone;
          orderObj.customerEmail = application.email;

          application.id = applicationId;
          orderObj.applicationId = applicationId;

          orderObj.giftId = gift.id;
          orderObj.giftName = gift.name;
          orderObj.giftImageLink = gift.imageLink;
          orderObj.giftPrice = gift.price;
          orderObj.giftDeposit = gift.deposit;

          section.value++;
          document.querySelector('#top-anchor')?.scrollIntoView(true);

          //easterEggAnim.play();
          setTimeout(() => {
            if (currBrandId == 'elemental-medical-wishpro') {
              easterEggAnim.play();
            } else {
              easterEggAnim.playSegments([0, 285], true);
            }
            easterEggAnim.addEventListener('complete', async () => {
              isGiftModalOpened.value = true;
            });
          }, 1000);
        }
      });
    }
    const sendOrderToDatabase = async (paypalPaymentDetails = null) => {
      const dismissLoading = () => {
        loadingController.dismiss();
        orderObj.submittingOrder = false;
      }
      const loading = await loadingController.create({ duration: 30000 });
      await loading.present();

      orderObj.submittingOrder = true;
      orderObj["totalPrice"] = getOrderTotalPrice();
      orderObj["paypalPaymentDetails"] = paypalPaymentDetails;

      const { paymentMethod } = orderObj;

      if (paymentMethod == 'card') {
        const result = await stripe.value?.createToken(card.value);
        if (result?.error) {
          // Inform the user if there was an error.
          cardErrors.value.textContent = result.error.message;
          dismissLoading();
          return false;
        } else {
          orderObj.stripeToken = result?.token.id || ""; // pass the token to server for creating a payment
        }
      }
      const res: any = await api.createNewOrder(orderObj);
      dismissLoading();

      console.log(res);
      const { id, code, status, stripeErrorMsg, deliveryDate, deliveryTime, location,
                giftName, giftPrice, giftDeposit, transactionFee, totalPrice, } = res.order;
      console.log({ orderId: id, orderCode: code, orderStatus: status, paymentMethod });

      if (stripeErrorMsg) {
        presentAlert("信用卡付款失敗，請檢查信用卡資料或選擇其他付款方式。");
        return false;
      }
      else {
        // Go to thank you page
        router.replace({ path: '/thank-you', query: {
          orderId: id, orderCode: code, orderStatus: status, paymentMethod,
          gn: giftName, gp: giftPrice, gd: giftDeposit, tf: transactionFee, tp: totalPrice,
          dd: deliveryDate, dt: deliveryTime, l: location,
          wp: currBrand.value.whatsapp,
        } });
      }
    }

    const submitOrder = async () => {
      presentPrompt("確認下單預約？", async () => {
        clearInterval(timer);
        alertController.dismiss();
        await sendOrderToDatabase();
      });
    }

    // Countdown Timer
    const startTimer = (duration, display) => {
      let currDuration = duration, minutes, seconds;
      timer = setInterval(async () => {
        minutes = parseInt("" + currDuration / 60, 10);
        seconds = parseInt("" + currDuration % 60, 10);

        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;

        display.textContent = minutes + ":" + seconds;

        if (--currDuration < 0) {
          clearInterval(timer);
          const callback = () => {
            section.value = 1;
          }
          presentAlert("未能在限時內完成下單，您將被重新導向至主頁。", false, callback);
        }
      }, 1000);
    }

    // On Enter Page
    onIonViewDidEnter(() => {
      // Retrieve Data from DB
      api.getAppPublicData().then(res => {
        holidayDates.value = res.holidays;
        currBrand.value = res.brands.find(b => b.id == currBrandId) || res.brands[0];
        if (currBrand.value) {
          // Link brand ID to application & order
          application.brandId = currBrand.value.id;
          orderObj.brandId = currBrand.value.id;

          // Booking options
          locationOptions.value = currBrand.value.locationOptions.split(" , ");
          orderObj.location = locationOptions.value[0];
        }
        loadingData.value = false;
      });

      // ReCAPTCHA
      /*
      window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('grecaptcha-div', {
        'size': 'invisible',
        'callback': (res: any) => {
          // reCAPTCHA solved, allow signInWithPhoneNumber.
        }
      });
      */

      // Lottie Init
      const container: any = document.querySelector('#lottie-animation');
      easterEggAnim = lottie.loadAnimation({
        name: "Easter Egg",
        container: container,
        renderer: 'svg',
        loop: false,
        autoplay: false,
        animationData: currBrandId == 'elemental-medical-wishpro' ? require('@/assets/wishpro/animation.json') : require('@/assets/animation.json'),
      });
      if (currBrandId == 'elemental-medical-wishpro') {
        easterEggAnim.setSpeed(0.6);
      }

      // PayPal button init
      const paypalConfig = {
        onClick: (data, actions) => {
          const orderForm: any = document.querySelector('#order-form');
          if (!orderForm.checkValidity()) {
            presentAlert("請輸入所有必填資料。");
            return actions.reject();
          }
          return actions.resolve();
        },
        createOrder: (data, actions) => {
          return actions.order.create({
            purchase_units: [{
              amount: {
                value: getOrderTotalPrice(),
                currency_code: 'HKD',
              },
              description: orderObj.giftName,
            }],
            application_context: {
              shipping_preference: 'NO_SHIPPING',
              locale: 'zh-HK',
            },
          });
        },
        onApprove: function(data, actions) {
          return actions.order.capture().then((details) => {
            console.log(details);
            // Handle different payment statuses
            if (details.status === 'COMPLETED' || details.status === 'PENDING') {
              // Store the payment details in your database
              sendOrderToDatabase(details);
              
            } else if (details.status === 'CANCELLED') {
              // Handle the cancelled payment status
            } else {
              // Handle the failed payment status
              presentAlert('PayPal 付款失敗，請重試或選擇其他付款方式。');
            }
          });
        },
        onCancel: (data) => {
          // Handle the cancellation of the payment
        },
        onError: (err) => {
          // Handle any errors that occur during the checkout process
          presentAlert('PayPal 付款過程出現錯誤，請重試或選擇其他付款方式。');
        },
        style: {
          layout: 'horizontal',
          color: 'gold',
          shape: 'rect',
          label: 'paypal',
          tagline: false,
        },
      };
      const paypalButtons = window["paypal"].Buttons(paypalConfig);
      paypalButtons.render('#paypal-button-container');
    });

    // Before Leaving Page
    onIonViewWillLeave(() => {
      /*
      window.recaptchaVerifier.clear();
      if (recaptchaDiv.value) {
        recaptchaDiv.value.innerHTML = '<div id="grecaptcha-div"></div>';
      }
      */
    })
    
    return {
      // icons
      personCircle, call, mail,

      // variables
      currBrandId,
      loadingData, currBrand, holidayDates,
      section,
      isGiftModalOpened,
      recaptchaDiv,
      nameInput, phoneInput, emailInput, submitBtn,
      paymentMethods: config.paymentMethods,
      application, orderObj,

      dateInputModal, availableTimeSlots, locationOptions,
      minDate: moment().format("YYYY-MM-DD"), maxYear: new Date().getFullYear() + 1,

      // stripe
      inviInput, cardElement, cardErrors,

      // methods
      focusInputField, formatDate, getProxyImgLink,
      submitApplication, updateApplication,
      getOrderTotalPrice, submitOrder,
      
      openImageModal: async (imageLink: any, caption = "") => {
        const modal = await modalController.create({
          component: ImageModal,
          componentProps: { imageLink, caption },
        });
        return modal.present();
      },

      isBookingDateEnabled: (dateString: string) => {
        const { bhHoliday, bhSat, bhSun } = currBrand.value;
        const utcDay = new Date(dateString).getUTCDay();

        if (!bhHoliday && holidayDates.value.includes(dateString)) return false;
        if (!bhSat && utcDay === 6) return false;
        if (!bhSun && utcDay === 0) return false;
        
        return true;
      },

      onSelectBookingDate: () => {
        orderObj.deliveryDate = formatDate(orderObj.deliveryDate, "D MMM YYYY");
        api.updateApplication(application.id, {
          'selectedBookingDate': orderObj.deliveryDate,
          'selectedBookingLocation': orderObj.location,
        });
        const dateInputModalRef: any = dateInputModal.value;
        dateInputModalRef.$el.dismiss();

        const getBusinessHour = (targetDate) => {
          const utcDay = new Date(targetDate).getDay();

          if (holidayDates.value.includes(formatDate(targetDate, "YYYY-MM-DD"))) {
            return currBrand.value.bhHoliday;
          }
          const dayCodes = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
          return currBrand.value[`bh${dayCodes[utcDay]}`];
        }

        // Get available timeslots according to business hours
        const [openTime, closeTime] = getBusinessHour(orderObj.deliveryDate).split(" - ");
        const openingHour = moment(openTime.split(":")[0], 'H'); // opens at 10:00
        const closingHour = moment(closeTime.split(":")[0], 'H'); // closes at 20:00
        const duration = 60, timeSlots: any = [];
        for (let h = moment(openingHour); h.isBefore(closingHour); h.add(duration, 'm')) {
          const endTime = moment(h).add(duration, 'm');
          timeSlots.push(`${h.format('HH:mm')} - ${endTime.format('HH:mm')}`);
        }
        availableTimeSlots.value = timeSlots;
      },

      onCompleteLuckyDraw: () => {
        isGiftModalOpened.value = false;
        section.value++; // go to checkout form
        document.querySelector('#top-anchor')?.scrollIntoView(true);

        // Record event
        updateApplication('enteredCheckoutForm', true);

        // Start countdown timer
        setTimeout(() => {
          const display = document.querySelector('.timer__countdown');
          startTimer(countdown, display);
        }, 500);
      },
    }
  }
});
